import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL;

const CallApi = async ({ url, method = 'get', its_json = true, body, showMessage = false, complete = false }) => {
    const header_fields = {};
    const TOKEN = localStorage.getItem('token');

    if (its_json) header_fields['Content-Type'] = 'application/json';
    if (TOKEN) header_fields['Authorization'] = 'Bearer ' + TOKEN;

    try {
        const fetch_api = await fetch(complete ? url : (API_URL + url), {
            method: method,
            headers: header_fields,
            body: its_json ? JSON.stringify(body) : body
        });

        if (fetch_api.status == 204) return null;

        const api_response = await fetch_api.json();

        if (api_response?.code == 401) {
            // toast.info(api_response?.message ?? 'Error interno');

            const validateLogOut = [
                'Su sesión ha expirado, por favor, vuelva a ingresar',
                'Su sesión fue cerrada, por favor, vuelva a ingresar',
            ];

            if (validateLogOut.includes(api_response?.message ?? '')) {
                toast.info(api_response?.message ?? 'Error interno');
                localStorage.removeItem('token');
                window.location.href = '/login';
            }

            return null;
        }

        if (showMessage && api_response?.message) {
            if (api_response?.code >= 400) throw new Error((api_response.message ?? 'Error al contactar con el servidor') + "_" + (api_response?.code ?? 400));
            if ([200, 201, 203].includes(api_response?.code) && its_json) toast.success(api_response.message);
        }

        return api_response;
    } catch (error) {
        const object_error = error?.message ? String(error?.message).split("_") : null;

        if (object_error.length == 2) {
            const getProperty = parseInt(object_error[1]) < 500 ? 'error' : 'info';

            toast[getProperty](object_error[0]);
        } else {
            toast.info("Error inesperado. Intenta de nuevo o contacta soporte");
        }
        console.error(error);
        return null;
    }
}

export default CallApi;